module.exports = __webpack_public_path__ + "static/media/questionAuthorImage.7903d289.svg";